export var filterOutReuseLanguageList = function filterOutReuseLanguageList(languageList) {
  var reuseList = [{
    mainCountryCode: 'DE',
    unUseCountryCodeList: ['AT']
  }, {
    mainCountryCode: 'GR',
    unUseCountryCodeList: ['CY']
  }, {
    mainCountryCode: 'GB',
    unUseCountryCodeList: ['IE']
  }];
  reuseList.forEach(function (item) {
    if (languageList.find(function (aItem) {
      return aItem.country === item.mainCountryCode;
    }) && languageList.find(function (aItem) {
      return item.unUseCountryCodeList.includes(aItem.country);
    })) {
      item.unUseCountryCodeList.forEach(function (code) {
        var theIndex = languageList.findIndex(function (aItem) {
          return aItem.country === code;
        });
        languageList.splice(theIndex, 1);
      });
    }
  });
  return languageList;
};
export var SpecificTextInSpecificLanguageEnum;

(function (SpecificTextInSpecificLanguageEnum) {
  SpecificTextInSpecificLanguageEnum["postCode"] = "postcode";
})(SpecificTextInSpecificLanguageEnum || (SpecificTextInSpecificLanguageEnum = {}));

export var modifyTextToSpecificTextInSpecificLanguage = function modifyTextToSpecificTextInSpecificLanguage(originText, config) {
  var text = originText;

  switch (config.type) {
    case SpecificTextInSpecificLanguageEnum.postCode:
      if (['IE'].includes(config === null || config === void 0 ? void 0 : config.country)) {
        text = 'Eircode';
      }

      break;

    default:
      break;
  }

  return text;
};